export const DEFAULT_THEME = 'LIEPAJA_THEME';

export const THEME_MODE_LIGHT = 'light';
export const THEME_MODE_DARK = 'dark';
export const THEME_MODE_CTRST_LIGHT = 'blackOnYellow';
export const THEME_MODE_CTRST_DARK = 'yellowOnBlack';

export const DEAULT_THEME_MODE = THEME_MODE_LIGHT;

export const THEME_MODES = [
  THEME_MODE_LIGHT,
  THEME_MODE_DARK,
  THEME_MODE_CTRST_LIGHT,
  THEME_MODE_CTRST_DARK,
];



// WEBPACK FOOTER //
// ./src/core/theme/constants.js